import { useMemo } from 'react';

import { IdentityMultiContentLayoutBase } from './IdentityMultiContentLayoutBase';
import { IdentityMultiContentLayoutProps, LayoutVariantConfig } from './types';

export const DESKTOP_CONFIG: LayoutVariantConfig = {
  contentGap: 3,
  footerGap: 2,
  stackedPaddingTop: 6,
  stackedWidth: 230,
  bottomStackedGap: 3,
  centerContent: false,
  pushFooterToBottom: false,
};

export function IdentityMultiContentLayoutDesktop(props: IdentityMultiContentLayoutProps) {
  const config = useMemo(() => {
    return {
      ...DESKTOP_CONFIG,
      ...(props.config ?? {}),
    };
  }, [props.config]);

  return <IdentityMultiContentLayoutBase {...props} config={config} />;
}
